var Obj = Object.create(null);
export default Obj;
